module.exports = __webpack_public_path__ + "static/img/activity.7d59b76.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon/fzkHome/activity.png
// module id = JtX8
// module chunks = 55